import { BaseHook } from './base.hook';

export class DepositFundsHook extends BaseHook {

  static path = 'DepositFunds.amount';

  static execute(path, value, actions) {
    const formatted = `$${parseFloat(value).toFixed(2)}`;
    actions.setData('DepositFunds.formattedAmount', formatted);
  }
}
